import api from "../../../core/api";
import { ManufacturerReference } from "../../inventory/models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.catalogApiBaseUrl };
}

class CustomerManufacturersApi {
  getManufacturers(): Promise<ManufacturerReference[]> {
    return api.get<ManufacturerReference[]>(`/v1/manufacturers`, getRequestConfig())
      .then(x => x.data);
  }
}

export default new CustomerManufacturersApi();